import React, { useState, useEffect } from 'react';
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import Select from 'react-select';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencil, faSpinner, faCheckCircle, faTruck, faBox, faTrash, faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';


function App() {
  const [tasks, setTasks] = useState([]);
  const [error, setError] = useState(null);
  const [editingRow, setEditingRow] = useState(null);
  const [formData, setFormData] = useState({
    id: null,
    title: '',
    description: '',
    assigned_to: '',
    due_date: '',
    status: 'Приета поръчка',
    price: '',
  });

  const initialNewTask = {
    title: '',
    assigned_to: '',
    due_date: '',
    status: 'Приета поръчка',
    price: '',
  };

  const [newTasks, setNewTasks] = useState({
    'Приета поръчка': { ...initialNewTask, status: 'Приета поръчка' },
    'Налични/Поръчани за склад': { ...initialNewTask, status: 'Налични/Поръчани за склад' },
    'Изработка на проект': { ...initialNewTask, status: 'Изработка на проект' },
    'Потвърден проект': { ...initialNewTask, status: 'Потвърден проект' },
    'Изработка на продукт': { ...initialNewTask, status: 'Изработка на продукт' },
    'Превоз между офиси': { ...initialNewTask, status: 'Превоз между офиси' },
    'Продукта очаква доставка': { ...initialNewTask, status: 'Продукта очаква доставка' },
    'Завършен': { ...initialNewTask, status: 'Завършен' },
  });

  useEffect(() => {
    axios.get('http://tasks.m-artbg.com/api/get_tasks.php')
      .then((response) => {
        if (Array.isArray(response.data) && response.data.length > 0) {
          setTasks(response.data);
        } else {
          setError('Няма налични задачи');
        }
      })
      .catch((err) => {
        console.error('Error fetching tasks:', err);
        setError('Грешка при зареждане на задачите!');
      });
  }, []);

  const getStatusIcon = (status) => {
    switch (status) {
      case 'Приета поръчка': return <FontAwesomeIcon icon={faCheckCircle} />;
      case 'Налични/Поръчани за склад': return <FontAwesomeIcon icon={faBox} />;
      case 'Изработка на проект': return <FontAwesomeIcon icon={faSpinner} spin />;
      case 'Потвърден проект': return <FontAwesomeIcon icon={faCheckCircle} />;
      case 'Изработка на продукт': return <FontAwesomeIcon icon={faSpinner} />;
      case 'Превоз между офиси': return <FontAwesomeIcon icon={faTruck} />;
      case 'Продукта очаква доставка': return <FontAwesomeIcon icon={faTruck} />;
      case 'Завършен': return <FontAwesomeIcon icon={faCheckCircle} />;
      default: return <FontAwesomeIcon icon={faQuestionCircle} />;
    }
  };

  const groupTasksByStatus = () => {
    const grouped = {};
    tasks.forEach((task) => {
      if (!grouped[task.status]) {
        grouped[task.status] = [];
      }
      grouped[task.status].push(task);
    });
    return grouped;
  };

  const handleEdit = (task) => {
    setEditingRow(task.id);
    setFormData(task);
  };

  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleEditSubmit = (e) => {
    e.preventDefault();

    axios.post('http://tasks.m-artbg.com/api/update_task.php', formData)
      .then(() => {
        setTasks((prev) =>
          prev.map((t) => (t.id === formData.id ? formData : t))
        );
        setEditingRow(null);
      })
      .catch((err) => console.error('Error updating task:', err));
  };

  const statusOptions = [
    { value: 'Приета поръчка', label: <><FontAwesomeIcon icon={faCheckCircle} /> Приета поръчка</> },
    { value: 'Налични/Поръчани за склад', label: <><FontAwesomeIcon icon={faBox} /> Налични/Поръчани за склад</> },
    { value: 'Изработка на проект', label: <><FontAwesomeIcon icon={faSpinner} spin /> Изработка на проект</> },
    { value: 'Потвърден проект', label: <><FontAwesomeIcon icon={faCheckCircle} /> Потвърден проект</> },
    { value: 'Изработка на продукт', label: <><FontAwesomeIcon icon={faSpinner} /> Изработка на продукт</> },
    { value: 'Превоз между офиси', label: <><FontAwesomeIcon icon={faTruck} /> Превоз между офиси</> },
    { value: 'Продукта очаква доставка', label: <><FontAwesomeIcon icon={faTruck} /> Продукта очаква доставка</> },
    { value: 'Завършен', label: <><FontAwesomeIcon icon={faCheckCircle} /> Завършен</> },
  ];
  

  const handleNewTaskChange = (status, e) => {
    const { name, value } = e.target;
    setNewTasks((prev) => ({
      ...prev,
      [status]: { ...prev[status], [name]: value },
    }));
  };

  const handleNewTaskSubmit = (status) => {
    const newTask = newTasks[status];

    axios.post('http://tasks.m-artbg.com/api/add_task.php', newTask)
      .then((response) => {
        const newId = response.data.id || `tmp-${Date.now()}`;
        setTasks((prev) => [...prev, { ...newTask, id: newId }]);

        setNewTasks((prev) => ({
          ...prev,
          [status]: { ...initialNewTask, status },
        }));
      })
      .catch((err) => console.error('Error adding new task:', err));
  };

  const handleRemoveTask = (taskId) => {
    axios.post('http://tasks.m-artbg.com/api/remove_task.php', { id: taskId })
      .then(() => {
        setTasks((prev) => prev.filter((task) => task.id !== taskId));
      })
      .catch((err) => console.error('Error removing task:', err));
  };

  const groupedTasks = groupTasksByStatus();

  return (
    <div className="container mt-4">
      <h1 className="mb-4">Тракер задачи</h1>
      <table className="table table-striped table-bordered">
        <thead>
          <tr>
            <th>Статус</th>
            <th>Задача</th>
            <th>Възложено на</th>
            <th>Дата създаване</th>
            <th>Дата изпълнение</th>
            <th>Цена</th>
            <th>Действия</th>
          </tr>
        </thead>
        <tbody>
          {[
            'Приета поръчка',
            'Налични/Поръчани за склад',
            'Изработка на проект',
            'Потвърден проект',
            'Изработка на продукт',
            'Превоз между офиси',
            'Продукта очаква доставка',
            'Завършен',
          ].map((status) => (
            <React.Fragment key={status}>
              {/* Status Header */}
              <tr className="table-info">
              <td colSpan="7" className="fw-bold text-danger">
          {getStatusIcon(status)} {/* Render the icon */}
          <span className="ms-2">{status}</span>
        </td>
              </tr>
              {groupedTasks[status]?.map((task) => (
                <tr key={task.id}>
                {editingRow === task.id ? (
                  <>
                    <td>
                      <Select
                        value={statusOptions.find((option) => option.value === formData.status)}
                        onChange={(selectedOption) =>
                          setFormData((prev) => ({ ...prev, status: selectedOption.value }))
                        }
                        options={statusOptions}
                        styles={{
                          control: (base) => ({
                            ...base,
                            backgroundColor: '#282828',
                            border: '1px solid #444',
                            color: '#fff',
                            borderRadius: '4px',
                            minHeight: '40px',
                          }),
                          menu: (base) => ({
                            ...base,
                            backgroundColor: '#333',
                            borderRadius: '8px',
                          }),
                          option: (base, state) => ({
                            ...base,
                            backgroundColor: state.isFocused ? '#444' : '#333',
                            color: state.isSelected ? '#fff' : '#fff',
                          }),
                          singleValue: (base) => ({
                            ...base,
                            color: '#fff',
                          }),
                          placeholder: (base) => ({
                            ...base,
                            color: '#aaa',
                          }),
                          dropdownIndicator: (base) => ({
                            ...base,
                            color: '#fff',
                          }),
                        }}
                        isSearchable={false}
                        placeholder="Изберете статус"
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        name="title"
                        value={formData.title}
                        onChange={handleEditChange}
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        name="assigned_to"
                        value={formData.assigned_to}
                        onChange={handleEditChange}
                      />
                    </td>
                    <td>{task.created_at}</td>
                    <td>
                      <input
                        type="date"
                        name="due_date"
                        value={formData.due_date}
                        onChange={handleEditChange}
                      />
                    </td>
                    <td>
                      <input
                        type="number"
                        name="price"
                        value={formData.price}
                        onChange={handleEditChange}
                      />
                    </td>
                    <td>
                      <button className="btn btn-success btn-sm" onClick={handleEditSubmit}>
                        Запази
                      </button>
                    </td>
                  </>
                ) : (
                  <>
                    <td>
                      {getStatusIcon(task.status)} {task.status}
                    </td>
                    <td>{task.title}</td>
                    <td>{task.assigned_to}</td>
                    <td>{task.created_at}</td>
                    <td>{task.due_date}</td>
                    <td>{task.price} лв.</td>
                    <td>
                      <button
                        className="btn btn-primary btn-sm btn-edit"
                        onClick={() => handleEdit(task)}
                      >
                        <FontAwesomeIcon icon={faPencil} />
                      </button>{' '}
                      <button
                        className="btn btn-danger btn-sm"
                        onClick={() => handleRemoveTask(task.id)}
                      >
                        <FontAwesomeIcon icon={faTrash} />
                      </button>
                    </td>
                  </>
                )}
                </tr>
              ))}
              {/* New Task Row */}
              <tr>
                <td>
                  <Select
                    value={statusOptions.find((option) => option.value === newTasks[status].status)}
                    onChange={(selectedOption) =>
                      setNewTasks((prev) => ({
                        ...prev,
                        [status]: { ...prev[status], status: selectedOption.value },
                      }))
                    }
                    options={statusOptions}
                    styles={{
                      control: (base) => ({
                        ...base,
                        backgroundColor: '#282828',
                        border: '1px solid #444',
                        color: '#fff',
                        borderRadius: '4px',
                        minHeight: '40px',
                      }),
                      menu: (base) => ({
                        ...base,
                        backgroundColor: '#333',
                        borderRadius: '8px',
                      }),
                      option: (base, state) => ({
                        ...base,
                        backgroundColor: state.isFocused ? '#444' : '#333',
                        color: state.isSelected ? '#fff' : '#fff',
                      }),
                      singleValue: (base) => ({
                        ...base,
                        color: '#fff',
                      }),
                      placeholder: (base) => ({
                        ...base,
                        color: '#aaa',
                      }),
                      dropdownIndicator: (base) => ({
                        ...base,
                        color: '#fff',
                      }),
                    }}
                    isSearchable={false}
                    placeholder="Изберете статус"
                  />
                </td>
                <td>
                  <input
                    type="text"
                    name="title"
                    value={newTasks[status].title}
                    onChange={(e) => handleNewTaskChange(status, e)}
                    placeholder="Заглавие"
                  />
                </td>
                <td>
                  <input
                    type="text"
                    name="assigned_to"
                    value={newTasks[status].assigned_to}
                    onChange={(e) => handleNewTaskChange(status, e)}
                    placeholder="Възложено на"
                  />
                </td>
                <td />
                <td>
                  <input
                    type="date"
                    name="due_date"
                    value={newTasks[status].due_date}
                    onChange={(e) => handleNewTaskChange(status, e)}
                  />
                </td>
                <td>
                  <input
                    type="number"
                    name="price"
                    value={newTasks[status].price}
                    onChange={(e) => handleNewTaskChange(status, e)}
                    placeholder="Цена"
                  />
                </td>
                <td>
                  <button
                    className="btn btn-primary btn-sm"
                    onClick={() => handleNewTaskSubmit(status)}
                  >
                    Добави
                  </button>
                </td>
              </tr>
              {/* Blank Space */}
              <tr>
                <td colSpan="7" style={{ height: '20px', backgroundColor: '#f8f9fa' }}></td>
              </tr>
            </React.Fragment>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default App;
